module.exports = __webpack_public_path__ + "media/img/banner/onboarding-778b07ce7554d6020cd91d4a5b4e4450.png";